import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SHA1 } from 'crypto-js';
import { environment } from '../../../environments/environment';
import {
  DOMAIN_PURESPECTRUM,
  DOMAIN_SPECTRUM_SURVEYS,
  ENV_QA_API_URL,
  ENV_QA_PATTERN,
  ENV_STAGING_URL,
  MP_REDIRECT_OPTIONS,
} from './buyer-survey-simulator.constants';

@Component({
  selector: 'ps-buyer-survey-simulator',
  templateUrl: './buyer-survey-simulator.component.html',
  styleUrls: ['./buyer-survey-simulator.component.scss'],
})
export class BuyerSurveySimulatorComponent implements OnInit, OnDestroy {
  answerChoices = MP_REDIRECT_OPTIONS;
  status: number | undefined;
  paramsData: Params = {};
  private _mpRedirectUrl = environment.pureSpectrum.url;

  constructor(private _route: ActivatedRoute) {
    this.paramsData = this._route.snapshot.queryParams;
  }

  ngOnInit(): void {
    document.body.classList.add('buyer-survey-simulator-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('buyer-survey-simulator-page');
  }

  initiateRedirection(status: number) {
    const baseUrl = this._determineBaseUrl(document.referrer);
    const redirectUrl = this._constructRedirectUrl(baseUrl, status);
    this._redirectToUrl(redirectUrl);
  }

  private _determineBaseUrl(referrer: string): string {
    if (!referrer) {
      return this._mpRedirectUrl;
    }

    try {
      const url = new URL(referrer);
      const host = url.hostname;

      if (host.includes(DOMAIN_PURESPECTRUM)) {
        if (host.includes('qa')) {
          const match = host.match(ENV_QA_PATTERN);
          if (match) {
            return ENV_QA_API_URL(match[1]);
          }
        }
        if (host.includes('dev') || host.includes('staging')) {
          return ENV_STAGING_URL;
        }
      }

      if (host.includes(DOMAIN_SPECTRUM_SURVEYS)) {
        return url.origin;
      }
    } catch {
      // Fallback on invalid URL
    }

    return this._mpRedirectUrl;
  }

  private _constructRedirectUrl(baseUrl: string, status: number): string {
    const url = new URL(`${baseUrl}/surveydone`);
    url.searchParams.set('st', status.toString());

    Object.entries(this.paramsData).forEach(([key, value]) => {
      url.searchParams.set(key, String(value));
    });

    if (status === 21 && this.paramsData.transaction_id) {
      const hashUrl = `${baseUrl}/surveydone?st=${status}&transaction_id=${this.paramsData.transaction_id}`;
      const psHash = SHA1(hashUrl).toString();
      url.searchParams.set('ps_hash', psHash);
    }

    return url.toString();
  }

  private _redirectToUrl(url: string) {
    window.location.replace(url);
  }
}
